// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"b6dbe29d","244":"d5e2528b","422":"6c7eb12d","522":"033484f9","914":"0f03ac08","948":"3d392a89"}[chunkId] + ".chunk.js";
};